
export const getReportFooterBreakdown = () => {

  return [
    {
      title: '',
      subCategories: [
        {
          title: '',
          visible: true,
          isInfoBlock: true,
          lines: [
            {
              description: `**HealthySteps Return on Investment (ROI)** is a measure of cross-sector savings generated by a specific HealthySteps site compared to program costs.

              Results are based on HealthySteps services provided to children and families over a one-year time period and associated costs to operate HealthySteps over the same time period (annualized for long-term savings). Savings are estimated for the population served during the one-year timeframe and accrue in both the short-term and long-term (e.g. a child served by HealthySteps may generate reduced medical costs within 1 year and reduced special education costs over 15 years). Savings and operating costs are displayed in current dollars.

              **Short-term ROI** includes savings that accrue within a one-year timeframe.

              **Long-term ROI** includes savings that accrue over a timeframe of one year or longer.

              **A negative ROI** indicates that program costs generated by the HealthySteps site exceed savings generated over the associated timeframe.

              **A positive ROI** indicates that savings generated by the HealthySteps site exceed program costs over the associated timeframe.`,
              values: ['', '', ''],
              displayDefault: true,
            }
          ]
        }
      ]
    }
  ]
}

export default {
  getReportFooterBreakdown
};